import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// noinspection ES6CheckImport
import { Redirect } from 'react-router-dom';
import InputMask from 'react-input-mask';
import ReactLoading from 'react-loading';
import firebase from '../../../config/firebase';
import 'firebase/auth';
import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import getCep from '../../../services/getCep';
import * as S from './styles';
import { PLAN_TYPES } from '../../../utils/constants';
import { logIn } from '../../../store/ducks/auth';
import { createUser } from '../../../database/repositories/UserRepository';

function SignUpView() {
  const [img, setImg] = useState('');
  const [imgName, setImgName] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [repPass, setRepPassword] = useState('');
  const [cpf, setCpf] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneAlternative, setPhoneAlternative] = useState('');
  const [cep, setCep] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [district, setDistrict] = useState('');
  const [address, setAddress] = useState('');
  const [houseNumber, setHouseNumber] = useState('');
  const [addrComplement, setAddrComplement] = useState('');
  const [sms, setSms] = useState('off');
  const [msgType, setMsgType] = useState(null);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(0);
  const [plan, setPlan] = useState('');
  const [planDuration, setPlanDuration] = useState('1');

  const dispatch = useDispatch();

  const storage = firebase.storage();

  const fetchAddressByCEP = (cepCode) =>
    getCep(cepCode).then((data) => {
      setState(data.uf);
      setCity(data.city);
      setDistrict(data.neighborhood);
      setAddress(data.street);
    });

  function validateInputFields() {
    // if (!img) {
    //   setMsgType('error');
    //   setMsg('Imagem faltando');
    //   return false;
    // }
    if (!name) {
      setMsgType('error');
      setMsg('Informar o nome.');
      return false;
    }
    if (!email || !password) {
      setMsgType('error');
      setMsg('É necessário informar o email e a senha para realizar o cadastro.');
      return false;
    }
    if (password !== repPass) {
      setMsgType('error');
      setMsg('Senha e a repetição de senha diferem.');
      return false;
    }
    if (!cep) {
      setMsgType('error');
      setMsg('Informar o CEP');
      return false;
    }
    if (!state || !city || !district || !address) {
      setMsgType('error');
      setMsg(
        'Informar endereço completo. Informe o CEP e faremos o melhor possível pra determinar seu' +
          ' endereço automaticamente. Se faltar algo, por favor preencha manualmente.'
      );
      return false;
    }
    if (!phone) {
      setMsgType('error');
      setMsg('Informar um telefone celular válido.');
      return false;
    }
    if (!cpf) {
      setMsgType('error');
      setMsg('Informar CPF.');
      return false;
    }
    // if (!plan) {
    //   setMsgType('error');
    //   setMsg('Qual plano deseja usar? Escolha um plano.');
    //   return false;
    // }
    return true;
  }

  async function signup() {
    if (validateInputFields()) {
      setMsgType('success');
      setMsg('');
    } else {
      setMsgType('error');
      setLoading(0);
      return false;
    }

    setMsg('Criando conta...');
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((credential) => {
        if (img) {
          console.log('salvando img');
          storage
            .ref(`imagens/${credential.user.uid}/prof_img_${imgName}`)
            .putString(img, 'data_url')
            .then(() => {
              console.log('Save Image Result: OK');
              setMsg('Imagem de perfil salva, salvando dados de usuário...');

              const userData = {
                name,
                email,
                plan,
                plan_duration: planDuration,
                addresses: [
                  {
                    zip: cep,
                    state,
                    city,
                    district,
                    address,
                    number: houseNumber,
                    complement: addrComplement
                  }
                ],
                phone,
                phoneAlternative,
                cpf,
                sms,
                photo: `prof_img_${imgName}`,
                joinDate: Date.now()
              };

              dispatch(logIn(credential.user.uid, email, userData));
              return createUser(credential.user.uid, userData)
                .then(() => {
                  console.log('Save/Add Userdata Result: OK');
                  setMsg('Cadastro concluído com sucesso!');
                })
                .catch((error) => {
                  setMsgType('error');
                  setMsg('Erro: dados de usuário não salvos.');
                  console.log('Erro ao salvar dados de usuário:');
                  console.log(error.message);
                });
            })
            .catch((errror) => {
              setMsgType('error');
              setMsg('Erro: imagem de perfil não salva.');
              console.log(JSON.stringify(errror));
            });
        } else {
          console.log('sem img');
          const userData = {
            name,
            email,
            plan,
            plan_duration: planDuration,
            addresses: [
              {
                zip: cep,
                state,
                city,
                district,
                address,
                number: houseNumber,
                complement: addrComplement
              }
            ],
            phone,
            phoneAlternative,
            cpf,
            sms,
            photo: '../../../assets/avataruser.png',
            joinDate: Date.now()
          };
          dispatch(logIn(credential.user.uid, email, userData));
          return createUser(credential.user.uid, userData)
            .then(() => {
              console.log('Save/Add Userdata Result: OK');
              setMsg('Cadastro concluído com sucesso!');
            })
            .catch((error) => {
              setMsgType('error');
              setMsg('Erro: dados de usuário não salvos.');
              console.log('Erro ao salvar dados de usuário:');
              console.log(error.message);
            });
        }
      })
      .catch((error) => {
        setMsgType('error');
        switch (error.message) {
          case 'Password should be at least 6 characters':
            setMsg('A senha deve ter pelo menos 6 caracteres!');
            break;
          case 'The email address is already in use by another account.':
            setMsg('Este email já está sendo utilizado por outro usuário!');
            break;
          case 'The email address is badly formatted.':
            setMsg('O formato do seu email é inválido!');
            break;
          default:
            setMsg('Não foi possível cadastrar. Tente novamente mais tarde!');
            break;
        }
        console.log(JSON.stringify(error));
      });
  }

  // function updateSelectedPlanCss(planID) {
  //   document.getElementById('div_plan_basic').className = 'signup-plan-card';
  //   document.getElementById('div_plan_standard').className = 'signup-plan-card';
  //   document.getElementById('div_plan_premium').className = 'signup-plan-card';
  //   document.getElementById(planID).classList.add('signup-plan-card-selected');
  // }

  const readFile = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();

      // Read the image via FileReader API and save image result in state.
      reader.onload = function (e) {
        // Add the file name to the data URL
        let dataURL = e.target.result;
        dataURL = dataURL.replace(';base64', `;name=${file.name};base64`);
        resolve({ file, dataURL });
      };

      reader.readAsDataURL(file);
    });

  const changeImage = async (e) => {
    const { file, dataURL } = await readFile(e.target.files[0]);
    setImg(dataURL);
    setImgName(file.name);
  };

  return (
    <S.Container>
      {useSelector((storeState) => storeState.auth.user_logged_in) > 0 ? (
        <Redirect to="/#top" />
      ) : (
        <></>
      )}
      <Header />
      <NavBar />
      <MainContent>
        <div className="signup-content">
          <div className="signup-top-section">
            <form>
              <div className="signup-top-section-left">
                <h3>Foto</h3>
                {img ? (
                  <div className="signup-photo-circle">
                    <img id="signup_photo_img" src={img} alt="alt" />
                  </div>
                ) : (
                  <div className="signup-photo-circle">
                    <div id="signup_photo_placeholder" style={{ textAlign: 'center' }}>
                      <i className="fas fa-camera" />
                      <p>ESCOLHA SUA MELHOR FOTO</p>
                    </div>
                  </div>
                )}
                <div className="profile-photo-upload-button-wrapper">
                  <input type="button" value="ESCOLHER FOTO" />
                  <input type="file" onChange={changeImage} />
                </div>
              </div>
              <div className="signup-top-section-right">
                <ul>
                  <li>
                    <h3>Nome</h3>
                    <input
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      placeholder="Nome completo"
                    />
                  </li>
                  <li>
                    <h3>E-mail</h3>
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      placeholder="Use seu melhor e-mail"
                    />
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>Senha</h3>
                      <input
                        onChange={(e) => setPassword(e.target.value)}
                        type="password"
                        placeholder="Mínimo 6 caractéres"
                      />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                      <h3>Repetir Senha</h3>
                      <input
                        onChange={(e) => setRepPassword(e.target.value)}
                        type="password"
                        placeholder="Senha de novo"
                      />
                    </div>
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>CEP</h3>
                      <InputMask
                        onBlur={(e) => fetchAddressByCEP(e.target.value)}
                        onChange={(e) => setCep(e.target.value)}
                        type="text"
                        placeholder="Insira seu CEP"
                        id="cep_input"
                        mask="99999-999"
                      />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                      <h3>Estado</h3>
                      <input
                        value={state}
                        type="text"
                        placeholder="Nome de seu estado"
                        id="state_input"
                      />
                    </div>
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>Cidade</h3>
                      <input
                        value={city}
                        type="text"
                        placeholder="Nome da cidade"
                        id="city_input"
                      />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                      <h3>Bairro</h3>
                      <input
                        value={district}
                        type="text"
                        placeholder="Bairro ou localidade"
                        id="district_input"
                      />
                    </div>
                  </li>
                  <li>
                    <h3>Endereço</h3>
                    <input
                      value={address}
                      type="text"
                      placeholder="Rua, avenida, etc"
                      id="address_input"
                    />
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>Número</h3>
                      <input
                        onChange={(e) => setHouseNumber(e.target.value)}
                        value={houseNumber}
                        type="text"
                        placeholder="Número da casa, prédio, etc."
                      />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                      <h3>Complemento</h3>
                      <input
                        onChange={(e) => setAddrComplement(e.target.value)}
                        value={addrComplement}
                        type="text"
                        placeholder="Complemento do endereço, se houver"
                      />
                    </div>
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>Telefone</h3>
                      <InputMask
                        mask="(99) 99999 9999"
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="(__) _____ _____"
                      />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                      <h3>Telefone Alternativo</h3>
                      <InputMask
                        mask="(99) 99999 9999"
                        onChange={(e) => setPhoneAlternative(e.target.value)}
                        placeholder="(__) _____ _____"
                      />
                    </div>
                  </li>
                  <li className="signup-form-row">
                    <div>
                      <h3>CPF</h3>
                      <InputMask
                        onChange={(e) => setCpf(e.target.value)}
                        mask="999.999.999-99"
                        placeholder="___.___.___-__"
                      />
                    </div>
                  </li>
                </ul>
                <label htmlFor="input_sms" onClick={() => setSms(sms === 'on' ? 'off' : 'on')}>
                  <span className="sms-checkbox-wrapper">
                    <i
                      className="fas fa-check"
                      id="input_sms_check"
                      style={{ color: sms === 'off' ? 'white' : '#303030' }}
                    />
                  </span>
                  Receber SMS com anúncios
                </label>
              </div>
            </form>
          </div>
        </div>
      </MainContent>
      {/* <div className="flex-full-center flex-column" style={{ background: '#002666' }}>
        <div className="signup-mid-section">
          <h1>Planos</h1>
          <div className="signup-mid">
            <div className="signup-plan-card" id="div_plan_basic">
              <h3>Basic</h3>
              <h2>
                <span>R$</span>
                1,00
                <strong>/m</strong>
              </h2>
              <p>Lorem Ipsum</p>
              <p>Lorem Ipsum</p>
              <p>Lorem Ipsum</p>
              <p style={{ border: 'none' }}>Selecionar Duração:</p>
              <br />
              <div className="select-container">
                <label>
                  <select id="plan_basic">
                    <option value="1">1 mês - R$1,00/mês</option>
                    <option value="3">3 meses - R$1,00/mês</option>
                    <option value="6">6 meses - R$1,00/mês</option>
                  </select>
                  <i className="fas fa-chevron-down" />
                </label>
              </div>
              <div className="flex-full-center">
                <button
                  onClick={() => {
                    setPlan(PLAN_TYPES.BASIC);
                    setPlanDuration(document.getElementById('plan_basic').value);
                    updateSelectedPlanCss('div_plan_basic');
                  }}
                  type="button">
                  ESCOLHER
                </button>
              </div>
            </div>
            <div className="signup-plan-card" id="div_plan_standard">
              <h3>Standard</h3>
              <h2>
                <span>R$</span>
                29,99
                <strong>/m</strong>
              </h2>
              <p>Lorem Ipsum</p>
              <p>Lorem Ipsum</p>
              <p>Lorem Ipsum</p>
              <p style={{ border: 'none' }}>Selecionar Duração:</p>
              <br />
              <div className="select-container">
                <label>
                  <select id="plan_standard">
                    <option value="1">1 mês - R$29,90/mês</option>
                    <option value="3">3 meses - R$29,90/mês</option>
                    <option value="6">6 meses - R$29,90/mês</option>
                  </select>
                  <i className="fas fa-chevron-down" />
                </label>
              </div>
              <div className="flex-full-center">
                <button
                  onClick={() => {
                    setPlan(PLAN_TYPES.STANDARD);
                    setPlanDuration(document.getElementById('plan_standard').value);
                    updateSelectedPlanCss('div_plan_standard');
                  }}
                  type="button">
                  ESCOLHER
                </button>
              </div>
            </div>
            <div className="signup-plan-card" id="div_plan_premium">
              <h3>Premium</h3>
              <h2>
                <span>R$</span>
                39,90
                <strong>/m</strong>
              </h2>
              <p>Lorem Ipsum</p>
              <p>Lorem Ipsum</p>
              <p>Lorem Ipsum</p>
              <p style={{ border: 'none' }}>Selecionar Duração:</p>
              <br />
              <div className="select-container">
                <label>
                  <select id="plan_premium">
                    <option value="1">1 mês - R$39,90/mês</option>
                    <option value="3">3 meses - R$39,90/mês</option>
                    <option value="6">6 meses - R$39,90/mês</option>
                  </select>
                  <i className="fas fa-chevron-down" />
                </label>
              </div>
              <div className="flex-full-center">
                <button
                  onClick={() => {
                    setPlan(PLAN_TYPES.PREMIUM);
                    setPlanDuration(document.getElementById('plan_premium').value);
                    updateSelectedPlanCss('div_plan_premium');
                  }}
                  type="button">
                  ESCOLHER
                </button>
              </div>
            </div>
          </div>
        </div>

      </div> */}
      <div className="signup-bot-section">
        {loading ? (
          <ReactLoading type="spinningBubbles" color="#002666" height={60} width={60} />
        ) : (
          <button onClick={signup} type="button">
            Finalizar Cadastro
          </button>
        )}
        {msgType != null && <p>{msg}</p>}
      </div>
      <Footer />
    </S.Container>
  );
}

export default SignUpView;
